/**
 * Load hybrid demos enabled for the current Host (or optional override).
 */
import { useEffect, useState } from 'react';
import { getPublicHybridDemosApi } from '../api/demoAssistants.api';

export default function usePublicHybridDemos(hostOverride = null) {
  const [state, setState] = useState({
    loading: true,
    error: null,
    enabled: true,
    demos: [],
    defaultDemoId: 'recruiting',
    source: null,
    registryIds: [],
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getPublicHybridDemosApi(hostOverride || undefined);
        if (cancelled) return;
        setState({
          loading: false,
          error: null,
          enabled: Boolean(res?.enabled),
          demos: Array.isArray(res?.demos) ? res.demos : [],
          defaultDemoId: res?.defaultDemoId || res?.demos?.[0]?.id || 'recruiting',
          source: res?.source || null,
          registryIds: Array.isArray(res?.registryIds) ? res.registryIds : [],
        });
      } catch (err) {
        if (cancelled) return;
        // Fail open on apex marketing if API blips — keep known paths usable
        setState((prev) => ({
          ...prev,
          loading: false,
          error: err?.message || err?.error || 'Could not load demos',
          enabled: true,
          demos: prev.demos.length ? prev.demos : [],
        }));
      }
    })();
    return () => { cancelled = true; };
  }, [hostOverride]);

  const isDemoEnabled = (id) => {
    if (state.loading) return true;
    if (!state.demos.length && state.source === 'platform_apex') return true;
    return state.demos.some((d) => d.id === id);
  };

  return { ...state, isDemoEnabled };
}
